import { render, staticRenderFns } from "./SyncPlayerIdentifierView.vue?vue&type=template&id=03f671a3&"
import script from "./SyncPlayerIdentifierView.vue?vue&type=script&lang=js&"
export * from "./SyncPlayerIdentifierView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports